module.exports = __webpack_public_path__ + "static/media/success-capture-2.bc0def10.png";